export const commentTransform = comment => ({
  name: comment['name'],
  body: comment['body'],
  createdAt: comment['created_at'],
  isApproved: comment['is_approved'],
});
